/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Ocop_Level_InvalidInputs */

const vi_error_shop_ocop_level_invalid = /** @type {(inputs: Error_Shop_Ocop_Level_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn cấp OCOP: Cấp tỉnh hoặc Cấp quốc gia.`)
};

/**

* @param {Error_Shop_Ocop_Level_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_ocop_level_invalid = /** @type {((inputs?: Error_Shop_Ocop_Level_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Ocop_Level_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_ocop_level_invalid(inputs)
});